import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField
} from '@mui/material';
import React from 'react';

export default function ChangeLogsFilters({
  filters,
  tableNames,
  changeSources,
  changedByUsers,
  onFilterChange
}) {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          alignItems: 'center'
        }}
      >
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Table</InputLabel>
          <Select
            value={filters.table_name}
            label="Table"
            onChange={(e) => onFilterChange('table_name', e.target.value)}
          >
            <MenuItem value="">All Tables</MenuItem>
            {tableNames.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Action</InputLabel>
          <Select
            value={filters.action}
            label="Action"
            onChange={(e) => onFilterChange('action', e.target.value)}
          >
            <MenuItem value="">All Actions</MenuItem>
            <MenuItem value="INSERT">INSERT</MenuItem>
            <MenuItem value="UPDATE">UPDATE</MenuItem>
            <MenuItem value="DELETE">DELETE</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 130 }}>
          <InputLabel>Source</InputLabel>
          <Select
            value={filters.change_source}
            label="Source"
            onChange={(e) => onFilterChange('change_source', e.target.value)}
          >
            <MenuItem value="">All Sources</MenuItem>
            {changeSources.map((source) => (
              <MenuItem key={source} value={source}>
                {source}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Changed By</InputLabel>
          <Select
            value={filters.changed_by}
            label="Changed By"
            onChange={(e) => onFilterChange('changed_by', e.target.value)}
          >
            <MenuItem value="">All Users</MenuItem>
            {changedByUsers.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.username}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          size="small"
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={filters.date_filter_start}
          onChange={(e) => onFilterChange('date_filter_start', e.target.value)}
        />

        <TextField
          size="small"
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={filters.date_filter_end}
          onChange={(e) => onFilterChange('date_filter_end', e.target.value)}
        />
      </Box>
    </Paper>
  );
}
